import { Navigate } from "react-router-dom";

/**
 * ProtectedRoute - Component to protect routes based on user role
 * 
 * @param {Object} props
 * @param {React.ReactNode} props.children - The component to render if access is allowed
 * @param {number} props.allowedRoleId - The role_id that is allowed to access this route (8 for Physiotherapist)
 * @param {string} props.redirectTo - The path to redirect to if access is denied
 * @param {boolean} [props.requireOnboarding=true] - When true, redirect to the physio
 *        onboarding stepper until onboarding is completed. Set false for the
 *        onboarding route itself to avoid a redirect loop.
 */
const ProtectedRoute = ({ children, allowedRoleId, redirectTo, requireOnboarding = true }) => {
  const storedRoleId = sessionStorage.getItem("usr_role_id");
  const roleId = storedRoleId ? parseInt(storedRoleId, 10) : null;

  // If no role_id is stored, redirect to login
  if (!roleId) {
    return <Navigate to="/" replace />;
  }

  // If role_id doesn't match, redirect to appropriate page
  if (roleId !== allowedRoleId) {
    return <Navigate to={redirectTo} replace />;
  }

  // Mandatory onboarding gate for Physiotherapy Center users. We only redirect
  // when the flag is explicitly "false" (set at login after checking for a
  // default address), so users from older sessions without the flag are never
  // blocked.
  if (requireOnboarding && sessionStorage.getItem("usr_physio_onboarded") === "false") {
    return <Navigate to="/physio_onboarding" replace />;
  }

  // Access granted
  return children;
};

export default ProtectedRoute;
